import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  InputAdornment,
  Stack,
  Button,
  FormControl,
  Select,
  MenuItem
} from "@mui/material";
import { useQuery } from "@apollo/client";
import SearchIcon from "@mui/icons-material/Search";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
//Import from project
import "../Style/pagestyle.scss";
import { SelectAcademicYear } from "../Components/Include/DynamicSelect";
import { GET_PAYMENT_ALL_TYPE } from "../Schema/SelectSchema"
import NotSendToPayInvoiceDetails from "../Components/ToPayInvoice/NotSendToPayInvoiceDetails";
import SentToPayInvoiceDetails from "../Components/ToPayInvoice/SentToPayInvoiceDetails"

export default function ToPayInvoice() {

  let invoiceTabNameFromLocal = JSON.parse(
    window.localStorage.getItem("invoiceTabNameFromLocal")
  );

  const [tabInvoiceName, setTabInvoiceName] = useState(invoiceTabNameFromLocal ? invoiceTabNameFromLocal : "notpay")
  let academicYearFromLocal = JSON.parse(
    window.localStorage.getItem("academicYearFromLocal")
  );

  const [selectAcedemicVal, setSelectAcedemicVal] = useState(
    academicYearFromLocal
      ? academicYearFromLocal
      : {
        id: "",
        title: "",
      }
  );

  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [paymentTypeData, setPaymentTypeData] = useState([])
  const [paymentType, setPaymentType] = useState("All")

  const { refetch } = useQuery(GET_PAYMENT_ALL_TYPE, {
    onCompleted: ({ getTypeOfPayment }) => {
      setPaymentTypeData(getTypeOfPayment);
      // console.log("getTypeOfPayment::", getTypeOfPayment)
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleTabNotPay = (tab) => {
    setTabInvoiceName(tab)
    window.localStorage.setItem("invoiceTabNameFromLocal", JSON.stringify(tab));
  }

  const handleTabPaid = (tab) => {
    setTabInvoiceName(tab)
    window.localStorage.setItem("invoiceTabNameFromLocal", JSON.stringify(tab));
  }

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    if (selectAcedemicVal?.id) {
      localStorage.setItem(
        "academicYearFromLocal",
        JSON.stringify(selectAcedemicVal?.id)
      );
    } else {
      setFromDate(null)
      setToDate(null)
    }
  }, [selectAcedemicVal?.id])

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">To pay announcement</Typography>
        </Stack>
      </Stack>

      <Box className="tabs-containner">
        <Box className="box-container">
          <Stack direction="row">
            <Button
              onClick={() => handleTabNotPay("notpay")}
              className={tabInvoiceName === "notpay" ? "active-btn-tabs" : "btn-tabs"}
            >
              Not send invoice
            </Button>

            <Button
              onClick={() => handleTabPaid("paid")}
              className={
                tabInvoiceName === "paid" ? "active-btn-tabs" : "btn-tabs"
              }
            >
              Sent invoice
            </Button>
          </Stack>
        </Box>
      </Box>

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">Search</Typography>
            <TextField
              placeholder="Search"
              size="small"
              className="search-field"
              onChange={(e) => handleSearch(e)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ mr: 1 }}>
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Typography className="search-head-title">Academic Year</Typography>
            <SelectAcademicYear
              selectedVal={selectAcedemicVal}
              setSelectedVal={setSelectAcedemicVal}
              className="search-field"
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">From</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={fromDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                disabled={selectAcedemicVal?.id ? false : true}
                onChange={(newValue) => {
                  setFromDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} sm={6} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">To</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={toDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                disabled={selectAcedemicVal?.id ? false : true}
                onChange={(newValue) => {
                  setToDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Typography className="search-head-title">Payment type</Typography>
            <FormControl fullWidth className="search-field">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                size="small"
                value={paymentType}
                onChange={(e) => {
                  setPage(1)
                  setPaymentType(e?.target?.value);
                }}
              >
                {
                  paymentTypeData?.map((row) => {
                    return (
                      <MenuItem key={row} value={row}>{row}</MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>

      <Box>
        {
          tabInvoiceName === "notpay" ?
            <NotSendToPayInvoiceDetails
              page={page}
              setPage={setPage}
              keyword={keyword}
              fromDate={fromDate}
              toDate={toDate}
              academicYearId={selectAcedemicVal?.id}
              paymentType={paymentType}
            /> :
            <SentToPayInvoiceDetails
              page={page}
              setPage={setPage}
              keyword={keyword}
              fromDate={fromDate}
              toDate={toDate}
              academicYearId={selectAcedemicVal?.id}
              paymentType={paymentType}
            />
        }
      </Box>
    </div>
  );
}
